import React, {useState, useEffect} from 'react';
import Card from './Card';
import Data from '../data/home';


function Privacy(props) {
    const [privacyData, setPrivacyData] = useState(Data.privacy);
        return ( 
            <>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 mb-4 mt-2 text-center">
                            <h2 style={{ fontWeight: '800'}}>{ privacyData.title }</h2>
                        </div>
                    </div>
                </div>
                <div className="container about-container" style={{ marginTop: '30px' }}>
                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            { privacyData.content.map((paragraph,index) => (
                                    <>
                                        <h3 style={{fontWeight: '600'}}>{paragraph.title}</h3> 
                                        <div style={{ fontStyle: 'italic'}}>{paragraph.date}</div>
                                        <div dangerouslySetInnerHTML={{__html: paragraph.body}} className="about-body"></div>
                                    </>
                                ) 
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
export default Privacy;